import React, { useState, useEffect, useCallback } from 'react';
import DatePicker from '..';
import styles from './styles.module.css';
import { CloseIcon } from '../../../../assets/icons/Close.icon';
import { ArrowIcon } from '../../../../assets/icons/Arrow.icon';
import { TwinArrowIcon } from '../../../../assets/icons/TwinArrow.icon';

/**
 * MobileFullscreenDatepicker
 * Props:
 * - open: boolean
 * - onClose: () => void
 * - selectionMode: 'range' | 'start' | 'end' (default 'range')
 * - value: { startDate: Date|null, endDate: Date|null }
 * - onChange: (value) => void
 * - onConfirm: (value) => void
 * - minDate, maxDate
 * - allowSameDay: boolean
 * - labels: { title?, start?, end?, confirm?, clear? }
 */
const MobileFullscreenDatepicker = ({
  open,
  onClose,
  onBack,
  selectionMode = 'range',
  value,
  onChange,
  onConfirm,
  minDate,
  maxDate,
  allowSameDay,
  labels = {},
}) => {
  const [selection, setSelection] = useState(() => value || { startDate: null, endDate: null });

  useEffect(() => {
    if (open) setSelection(value || { startDate: null, endDate: null });
  }, [open]);


  const handleChange = useCallback((val) => {
    setSelection(val);
    if (onChange) onChange(val);
  }, [onChange]);

  const handleConfirm = useCallback(() => {
    let payload = selection;
    if (selectionMode === 'start') {
      payload = { startDate: selection.startDate || null, endDate: (value && value.endDate) || null };
    } else if (selectionMode === 'end') {
      payload = { startDate: (value && value.startDate) || null, endDate: selection.endDate || null };
    }
    if (onConfirm) onConfirm(payload);
  }, [selection, onConfirm, selectionMode, value]);

  const handleClear = useCallback(() => {
    let cleared = { ...selection };
    if (selectionMode === 'start') {
      cleared = { startDate: null, endDate: selection.endDate || null };
    } else if (selectionMode === 'end') {
      cleared = { startDate: selection.startDate || null, endDate: null };
    } else {
      cleared = { startDate: null, endDate: null };
    }
    setSelection(cleared);
    if (onChange) onChange(cleared);
  }, [onChange, selection, selectionMode]);

  if (!open) return null;

  const todayStart = (() => { const t = new Date(); t.setHours(0,0,0,0); return t; })();
  const effectiveMinDate = minDate || todayStart;

  return (
    <div className={styles.overlay} role="dialog" aria-modal="true">
      <div className={styles.container}>
        <header className={styles.header}>
          <div className={styles.headerTitle}>
            <div onClick={onBack} role="button" tabIndex={0} aria-label="Voltar">
              <ArrowIcon size={24}/>
            </div>
            <div className={styles.headerTitleLabel}>
              {labels.title}
            </div>
            <div onClick={onClose} role="button" tabIndex={0} aria-label="Fechar">
              <CloseIcon onClick={onClose} className={styles.closeIcon} />
            </div>

          </div>

          <div className={styles.headerBody}>
          <div className={styles.previewSelection}>

            <div className={styles.previewSelectionItem}>
              <span>Data de ida</span>
              <strong> {selection.startDate ? selection.startDate.toLocaleDateString('pt-BR') : '---'}</strong>
            </div>
            <TwinArrowIcon size={28}  />
            <div className={styles.previewSelectionItem}>
              <span>Data de volta</span>
              <strong> {selection.endDate ? selection.endDate.toLocaleDateString('pt-BR') : '---'}</strong>
            </div>
            </div>
          </div>
        </header>

        <main className={styles.main}>
          <DatePicker
            variant="inline"
            selectionMode={selectionMode}
            value={selection}
            onChange={handleChange}
            minDate={effectiveMinDate}
            maxDate={maxDate}
            numberOfMonths={1}
            allowSameDay={allowSameDay}
            customHeaderClassName={styles.customHeaderDatepicker}
          />
        </main>

        <footer className={styles.footer}>
          <button type="button" className={styles.clear} onClick={handleClear}>{labels.clear || 'Limpar'}</button>
          <button type="button" className={styles.confirm} onClick={handleConfirm}>{labels.confirm || 'Confirmar'}</button>
        </footer>
      </div>
    </div>
  );
};

export default MobileFullscreenDatepicker;



// WEBPACK FOOTER //
// ./src/components/V2/datepicker/mobile-fullscreen/index.jsx